const mutations = {
  setIsMobile(state, isMobile) {
    state.isMobile = isMobile;
  },
};

export default mutations;


// WEBPACK FOOTER //
// ./src/common/mobile/vuex/mutations.js